export default {
    requirements: {
        low: {
            id: 'low',
            name: 'Low',
            totalFootage: 500,
            staffing: 1,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },

        medium: {
            id: 'medium',
            name: 'Medium',
            totalFootage: 1000,
            staffing:2,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },

        high: {
            id: 'high',
            name: 'High',
            totalFootage: 2500,
            staffing: 4,
            staffingCode: "da",
            equipment: [],
            software: [],
            otherItems: []
        },
    },

    ratingDetails: [
        {
            id: 'level',
            type: 'enum',
            required: false,
            component: 'PulloutQuestionMultiSwitchList',
            default: 0,
            label: "Level of Need:",
            options: [
                {
                    id: "none",
                    label: "None",
                    value: 0
                },

                {
                    id: "low",
                    label: "Low",
                    description: "up to 10,000 env per month",
                    value: 1
                },
                {
                    id: "medium",
                    label: "Medium",
                    description: "up to 30,000 env per month",
                    value: 2
                },
                {
                    id: "high",
                    label: "High",
                    description: "up to 150,000 env per month",
                    value: 3
                }
            ]
        }

    ]
}
